/**
 * Design tokens for the TwentyTwentysix redesign.
 * Use these in styled-components or pass to theme provider.
 * Extend as needed; do not break existing site styles.
 */
export const tokens = {
  colors: {
    primary: '#53BAB4',
    primaryDark: '#3d9a95',
    accent: '#F69B42',
    accentMuted: 'rgba(246, 155, 66, 0.62)',
    text: '#333333',
    textMuted: '#707070',
    background: '#ffffff',
    backgroundAlt: '#f8f8f8',
    border: '#e0e0e0',
  },
  typography: {
    fontFamily: "'Nunito Sans', -apple-system, BlinkMacSystemFont, sans-serif",
    fontFamilyHeading: "'Oswald', 'Nunito Sans', sans-serif",
    sizeXs: '12px',
    sizeSm: '14px',
    sizeBase: '16px',
    sizeLg: '18px',
    sizeXl: '24px',
    size2xl: '32px',
    size3xl: '40px',
    weightNormal: 400,
    weightMedium: 500,
    weightBold: 700,
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    section: '64px',
    sectionLg: '96px',
  },
  radius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    full: '9999px',
  },
  shadows: {
    sm: '0 1px 2px rgba(0,0,0,0.05)',
    md: '0 4px 6px rgba(0,0,0,0.07)',
    lg: '0 10px 15px rgba(0,0,0,0.1)',
  },
  container: {
    maxWidth: '1280px',
    maxWidthNarrow: '720px',
  },
};

export default tokens;
